/**
 * Determines if the current environment is a client environment.
 *
 * @returns The value of `import.meta.client`, indicating whether the code is running
 * in a client environment.
 *
 * @remarks
 * This function is essential for testing purposes, as we are facing challenges in
 * mocking `import.meta.client` directly. The function serves as a workaround to
 * facilitate testing by abstracting the direct access to `import.meta.client`.
 */
export function isClient() {
  return import.meta.client
}
